import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { useState } from 'react';
import ModalDialog, { ModalTransition } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { FeedFilters } from './FeedFilters';
import { useFeedWallParams } from 'hooks/useFeedWallParams';

export const MobileFeedWallFiltersPopup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { handleReset } = useFeedWallParams();

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleApplyFilters = () => {
    closeModal();
  };

  const handleResetFilters = () => {
    handleReset();
  };

  return (
    <>
      <Button onClick={openModal}>Filters</Button>
      <ModalTransition>
        {isOpen && (
          <ModalDialog onClose={closeModal}>
            <div css={modalContentStyles}>
              <h2 css={modalTitleStyles}>Filter Posts</h2>
              <FeedFilters />
              <div css={modalActionsStyles}>
                <Button onClick={handleResetFilters}>Reset</Button>
                <Button onClick={handleApplyFilters}>Apply</Button>
              </div>
            </div>
          </ModalDialog>
        )}
      </ModalTransition>
    </>
  );
};

const modalContentStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.200', '24px'),
  padding: token('space.200', '24px'),
  minWidth: 320,
  maxWidth: 480,
});

const modalTitleStyles = css({
  fontSize: '20px',
  fontWeight: token('font.weight.semibold', '600'),
  color: token('color.text', '#172B4D'),
  marginBottom: token('space.200', '24px'),
  marginTop: 0,
});

const modalActionsStyles = css({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: token('space.100', '8px'),
  marginTop: token('space.200', '24px'),
  paddingTop: token('space.200', '24px'),
  borderTop: `1px solid ${token('color.border', '#DFE1E6')}`,
});
